import React from 'react';
import PropTypes from 'prop-types';
import { Accordion as PrimeAccordion, AccordionTab as PrimeAccordionTab } from 'primereact/accordion';
import './Accordion.scss';

export const Accordion = ({ children, className = '', ...props }) => {
    return (
        <PrimeAccordion className={`custom-accordion ${className}`} {...props}>
            {children}
        </PrimeAccordion>
    );
};

export const AccordionTab = PrimeAccordionTab;

Accordion.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

